module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "chap-num"
  }, [_vm._v("Two")]), _vm._v(" "), _c('h3', {
    staticClass: "chap-title"
  }, [_vm._v("The leopard")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("While the whole community dreamt of the dead carpenter, Dad sat in our darkened room, talking deep into the night.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I listened to him, with dread in my heart, as he spoke words which heated up the air of the room. With blazing eyes, almost without purpose, he said: ‘Some people who are born don’t want to live. Others who are dead don’t want to die. Azaro, are you awake?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was surprised by the question.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes,’ I replied.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He carried on, as if I hadn’t said anything.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘My son, sometimes we find ourselves living in the dreams of the dead. Who knows the destination of a dream? How many worlds do we live in at the same time? When we sleep do we wake up in another world, in another time? When we sleep in that other world do we wake up here, in this world? Is history the converging dreams of many millions of people, living and dead? Have I just died and am I now living in another zone? Are we asleep all the time? When we wake, is it to one level above the deep sleep of our days? Do we wake when we die? My son, I "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("feel as if I have just died and yet I have never felt more awake.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He stopped again. His speech frightened me. Something incredible must have happened to him in the forest when he was burying the dead carpenter. It was as if he had burst out of a tight space which had been confining his raging spirit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then, in a sleepwalking voice, he suddenly cried out:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I have never felt more awake, but I see a leopard coming towards me. Am I a leopard? Is the leopard my dream? Look!’ he said, with an illuminated anguish in his voice, ‘The room is becoming brighter!’")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12568bea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/008_Part01Sub01Ch02.vue
// module id = 87
// module chunks = 0